import { render } from "./CascadeTagSelector.vue?vue&type=template&id=7246e2b4"
import script from "./CascadeTagSelector.vue?vue&type=script&lang=js"
export * from "./CascadeTagSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__